
<spike-editable-panel 
  title="Spedizione"
  [(isEditing)]="formView"
  (onSave)="save()"
  [isReadonly]="isReadOnly()"
  (onCancel)="formView.set(false)">
    <spike-position-shipping-form [form]="form"></spike-position-shipping-form>
  
</spike-editable-panel>
